module.exports = __webpack_public_path__ + "img/flag_en.6cc7a50f.svg";